import "./style.css";

function TextOptionTile({ label, onClick, isActive }) {

    return (
        <div className={`text-option-tile ${isActive && "active-tile"}`} onClick={() => {
            onClick(label);
        }}>
            <h6>{label}</h6>
        </div>
    );
}

export default TextOptionTile;